// extracted by mini-css-extract-plugin
export default {"main_wrapper":"PressRelease_main_wrapper__mbMHD","body":"PressRelease_body__kP2UG"};